const alerts = (state = [], action) => {
  switch (action.type) {
    case "SET_ALERTS_DATA":
      return action.data;
    default:
      return state;
  }
};

export default alerts;
